import axios from 'axios';

export const getPricelist = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}/pricelist`);
        return response.data;
    } catch (error) {
        console.error('Error fetching pricelist:', error);
        return { ok: false, message: 'Chyba pri načítaní cenníka' };
    }
};
